import { render, staticRenderFns } from "./choiceUser.vue?vue&type=template&id=4031981a&scoped=true"
import script from "./choiceUser.vue?vue&type=script&lang=js"
export * from "./choiceUser.vue?vue&type=script&lang=js"
import style0 from "./choiceUser.vue?vue&type=style&index=0&id=4031981a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031981a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4031981a')) {
      api.createRecord('4031981a', component.options)
    } else {
      api.reload('4031981a', component.options)
    }
    module.hot.accept("./choiceUser.vue?vue&type=template&id=4031981a&scoped=true", function () {
      api.rerender('4031981a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sensory/sensory-template/choiceUser.vue"
export default component.exports